import { ApexOptions } from 'apexcharts';
import { CHART_DEFAULT_OPTIONS } from '../options';

export const COMPARATIVE_WEEKS_OPTIONS: ApexOptions = {
  ...CHART_DEFAULT_OPTIONS,
};
